import { useMemo } from 'react'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

interface TimezoneSelectProps {
  value: string
  onChange: (tz: string) => void
}

function listTimezones(): string[] {
  const supported = (Intl as unknown as { supportedValuesOf?: (k: string) => string[] })
    .supportedValuesOf
  if (supported) {
    try {
      return supported('timeZone')
    } catch {
      // Fall through to the curated list below.
    }
  }
  return [
    'America/Los_Angeles',
    'America/Denver',
    'America/Chicago',
    'America/New_York',
    'America/Phoenix',
    'America/Anchorage',
    'Pacific/Honolulu',
    'UTC',
  ]
}

export function TimezoneSelect({ value, onChange }: TimezoneSelectProps) {
  const options = useMemo(listTimezones, [])

  return (
    <div className="space-y-2">
      <Label htmlFor="availability-timezone">Timezone</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger id="availability-timezone" className="w-[320px]">
          <SelectValue placeholder="Select timezone" />
        </SelectTrigger>
        <SelectContent className="max-h-72">
          {options.map((tz) => (
            <SelectItem key={tz} value={tz}>
              {tz}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-slate-500">
        Your recurring weekly schedule is defined in this timezone. Patients always see slots in
        their own timezone.
      </p>
    </div>
  )
}

